import React from 'react';
import {QuoteWrapper, QuoteText, QuoteAuthor} from './Quote.styles';

interface QuoteProps {
  text: string;
  author?: string;
}

export const Quote: React.FunctionComponent<QuoteProps> = (props) => {
  const author = props.author ? '- '.concat(props.author).toUpperCase() : null;
  return (
    <QuoteWrapper data-testid="quote-wrapper">
      <QuoteText>"{props.text}"</QuoteText>
      {author && <QuoteAuthor>{author}</QuoteAuthor>}
    </QuoteWrapper>
  );
};
